import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import LoginForm from './LoginForm';
import RegistrationForm from './RegistrationForm';
import ForgotPasswordForm from './ForgotPasswordForm';
import '../styles/LoginModal.css';

function LoginModal({ isOpen, onClose }) {
  const { checkAuth } = useAuth();
  const [view, setView] = useState('login'); // 'login', 'register', 'forgot'

  if (!isOpen) return null;

  const handleLoginSuccess = async (user) => {
    await checkAuth();
    onClose();
  };

  const handleRegistrationSuccess = () => {
    // Registration shows "check your email" message
    // User stays on registration view to see the message
  };

  const handleContinueAsGuest = () => {
    onClose();
  };

  const handleSwitchToRegister = () => {
    setView('register');
  };

  const handleSwitchToLogin = () => {
    setView('login');
  };

  const handleSwitchToForgot = () => {
    setView('forgot');
  };

  return (
    <div className="login-modal-overlay" onClick={onClose}>
      <div className="login-modal" onClick={(e) => e.stopPropagation()}>
        <button className="login-modal-close" onClick={onClose}>
          ✕
        </button>

        <div className="login-modal-content">
          {view === 'login' && (
            <>
              <div className="login-benefits">
                <h3>Benefits of Creating an Account:</h3>
                <ul>
                  <li>Save your Lit-Bits forever</li>
                  <li>Access from any device</li>
                  <li>Vote on avatars (including your own!)</li>
                  <li>Earn daily rewards</li>
                  <li>Track your voting stats</li>
                  <li>Compete on the leaderboard</li>
                </ul>
              </div>

              <LoginForm
                onSuccess={handleLoginSuccess}
                onSwitchToRegister={handleSwitchToRegister}
                onSwitchToForgot={handleSwitchToForgot}
              />
            </>
          )}

          {view === 'register' && (
            <>
              <div className="login-benefits">
                <h3>Join DripBattle Today!</h3>
                <ul>
                  <li>Save your Lit-Bits forever</li>
                  <li>Access from any device</li>
                  <li>Vote on avatars (including your own!)</li>
                  <li>Earn daily rewards</li>
                  <li>Track your voting stats</li>
                  <li>Compete on the leaderboard</li>
                </ul>
              </div>

              <RegistrationForm
                onSuccess={handleRegistrationSuccess}
                onSwitchToLogin={handleSwitchToLogin}
              />
            </>
          )}

          {view === 'forgot' && (
            <ForgotPasswordForm onBack={handleSwitchToLogin} />
          )}
        </div>
      </div>
    </div>
  );
}

export default LoginModal;
